import { host } from 'src/Branding/config';

export const useQueryLog = () => {
	const queryParams = new URLSearchParams(window.location.search);
	const sc = queryParams.get('sc');

	const sendLogToBackend = async (logEntry: string, logLevel: 'DEBUG' | 'INFO' | 'WARN' | 'ERROR' = 'INFO') => {
		const url = new URL(host + '/api/log');

		const body = {
			logEntry,
			logLevel,
			sc,
		};

		const requestOptions = {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(body),
		};

		return await fetch(url, requestOptions)
			.then((resData) => {
				return resData;
			})
			.catch((err: any) => {
				console.error('Error logging via backend: ', err);
			});
	};

	return { sendLogToBackend };
};
